import PsTopicPart from "./PsTopicPart";
import MomentGeneratingFunctionsGuide from "./MomentGeneratingFunctionsGuide";

export default function MomentGeneratingFunctionsPart2() {
  return (
    <PsTopicPart
      sectionId="ps-a-mgf-2"
      title="Moment Generating Functions — Part 2"
      path="/probability-statistics/moment-generating-functions/2"
      Guide={MomentGeneratingFunctionsGuide}
      part={2}
      nextPath="/probability-statistics/anova/1"
      nextLabel="Next: ANOVA"
    />
  );
}
